import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import { useNavigate, useParams } from "react-router-dom";
import useToast from "../../hooks/useToast";
import { useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";
import CategoryImage from "../../assets/images/test_category.jpeg"
interface sliderProps {
  sliderParentClass?: string;
  data: any;
  turnTeamName: string;
}

type CategoryCardImageProps = {
  src?: string;
  alt: string;
  className: string;
  priority?: boolean;
};

  export default function BoardSlider({ sliderParentClass, data, turnTeamName }: sliderProps) {
  const { t } = useTranslation();
  const [currentIndex, setCurrentIndex] = useState(0);
  const navigate = useNavigate();
  const { gameId } = useParams();
  const isLessThanXl = useMediaQuery("(max-width: 1280px)");
  const categoryGradientBg = {
    0: "bg-[linear-gradient(180deg,#00D2FF_0%,#3A7BD5_100%)]",
    1: "bg-[linear-gradient(180deg,#F2709C_0%,#FF9472_100%)]",
    2: "bg-[linear-gradient(180deg,#9BC5C3_0%,#616161_100%)]",
    3: "bg-[linear-gradient(180deg,#CBAD6D_0%,#D53369_100%)]",
    4: "bg-[linear-gradient(180deg,#F857A6_0%,#FF5858_100%)]",
    5: "bg-[linear-gradient(180deg,#38EF7D_0%,#11998E_100%)]",
  };

  const baseUrl = import.meta.env.VITE_BASE_CDN_URL;
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;

  // Define level configuration based on difficulty
  const levelConfig = {
    easy: { points: 200, order: 0 },
    medium: { points: 400, order: 1 },
    hard: { points: 600, order: 2 },
  };

  // Function to create levels from questions grouped by difficulty
  const createLevelsFromQuestions = (questions: any[]) => {
    if (!questions || questions.length === 0) return [];

    // Group questions by difficulty
    const grouped: Record<string, any[]> = { easy: [], medium: [], hard: [] };
    questions.forEach((q: any) => {
      const difficulty = q?.difficulty || "easy";
      if (grouped[difficulty]) {
        grouped[difficulty].push(q);
      }
    });

    // Create levels array from grouped questions
    const levels = Object.entries(grouped)
      .filter(([_, qs]) => qs.length > 0) // Only include levels that have questions
      .map(([difficulty, qs]) => ({
        difficulty,
        points: levelConfig[difficulty as keyof typeof levelConfig]?.points || 100,
        // Count questions as completed if answered OR timed out
        completed: qs.filter((q: any) => q.answered_by !== null || q.is_timeout === true).length,
        total: qs.length,
        questions: qs,
      }))
      .sort(
        (a, b) =>
          levelConfig[a.difficulty as keyof typeof levelConfig]?.order -
          levelConfig[b.difficulty as keyof typeof levelConfig]?.order
      );

    return levels;
  };

  const categories = data?.map((category: any, index: number) => ({
    id: category?._id,
    title: category?.category_id?.name?.[currentLanguage],
    img: `${baseUrl}/${category?.category_id?.gameboard_image || category?.category_id?.image?.[currentLanguage]}`,
    levels: createLevelsFromQuestions(category?.questions),
    gredientBg: categoryGradientBg[index % 6],
  }));

  //   const getVisibleCards = () => {
  //     const cards = [];
  //     for (let i = 0; i < 4; i++) {
  //       const index = (currentIndex + i) % categories.length;
  //       cards.push(categories[index]);
  //     }
  //     return cards;
  //   };

  const LevelDots = ({ questions }: { questions: any[] }) => {
    const getDotStyle = (question: any) => {
      if (question?.is_timeout) {
        // Red/crimson gradient for timed out questions
        return "bg-primary-orange";
      } else if (question?.answered_by !== null) {
        // Gold/orange gradient for completed questions
        return "bg-primary-orange";
      } else {
        // Gray/silver gradient for unanswered questions
        return "bg-light-gray";
      }
    };

    return (
      <div className={`${classNamesCategoryGrid.mainWrappergetDotSpacing[categories?.length]}`}>
        {questions.map((question, i) => (
          <div
            key={i}
            className={`${classNamesCategoryGrid.mainWrappergetDot[categories?.length]} lg:border-[0.0401vw] border-[0.77px] rounded-full bg-purple-fill border-black-300  ${getDotStyle(question)}`}
          />
        ))}
      </div>
    );
  };

  const classNamesCategoryGrid = {
    mainWrapperSpacing:{ 
      4:"4 2xl:pt-[0.2vw] xl:pt-0 md:pt-2 sm:pt-1 pt-1 landscape:max-xl:pt-0 landscape:max-md:pt-0",
      5:"4 2xl:pt-[0.2vw] xl:pt-0 md:pt-2 sm:pt-1 pt-1 landscape:max-xl:pt-0 landscape:max-md:pt-0",
      6: "6  xl:pt-0 md:pt-2 sm:pt-1 pt-1 landscape:max-xl:pt-0 landscape:max-md:pt-0",
      7: "6 2xl:pt-[0.2vw] xl:pt-0 md:pt-2 sm:pt-1 pt-1 landscape:max-xl:pt-0 landscape:max-md:pt-0",
      8: "8 2xl:pt-[0.2vw] xl:pt-0 md:pt-2 sm:pt-1 pt-1 landscape:max-xl:pt-0 landscape:max-md:pt-0",
      9: "8 2xl:pt-[0.2vw] xl:pt-0 md:pt-2 sm:pt-1 pt-1 landscape:max-xl:pt-0 landscape:max-md:pt-0",
      10: "10 2xl:pt-[0.2vw] xl:pt-0 md:pt-2 sm:pt-1 pt-1 landscape:max-xl:pt-0 landscape:max-md:pt-0"},

    mainWrappergetDotSpacing:{ 
      4:"flex 2xl:gap-[0.416vw] sm:gap-1 gap-0.5",
      5:"flex 2xl:gap-[0.416vw] sm:gap-1 gap-0.5",
      6: "flex 2xl:gap-[0.208vw] sm:gap-1 gap-0.5",
      7: "flex 2xl:gap-[0.208vw] sm:gap-1 gap-0.5",
      8: "flex 2xl:gap-[0.15625vw] sm:gap-1 gap-0.5",
      9: "flex 2xl:gap-[0.15625vw] sm:gap-1 gap-0.5",
      10: "flex 2xl:gap-[0.15625vw] sm:gap-1 gap-0.5"},

    mainWrappergetDot: {
      4:"2xl:w-[1.0416vw] xl:w-3 lg:w-2.5 md:w-2 w-1.5 2xl:h-[1.0416vw] xl:h-3 lg:h-2.5 md:h-2 h-1.5",
      5:"2xl:w-[1.0416vw] xl:w-3 lg:w-2.5 md:w-2 w-1.5 2xl:h-[1.0416vw] xl:h-3 lg:h-2.5 md:h-2 h-1.5",
      6: "2xl:w-[0.83vw] xl:w-4 lg:w-2.5 md:w-2 w-1.5 2xl:h-[0.83vw] xl:h-4 lg:h-2.5 md:h-2 h-1.5",
      7: "2xl:w-[0.83vw] xl:w-4 lg:w-2.5 md:w-2 w-1.5 2xl:h-[0.83vw] xl:h-4 lg:h-2.5 md:h-2 h-1.5",
      8: "2xl:w-[0.6390625vw] xl:w-3 lg:w-2.5 md:w-2 w-1.5 2xl:h-[0.6390625vw] xl:h-3 lg:h-2.5 md:h-2 h-1.5",
      9: "2xl:w-[0.6390625vw] xl:w-3 lg:w-2.5 md:w-2 w-1.5 2xl:h-[0.6390625vw] xl:h-3 lg:h-2.5 md:h-2 h-1.5",
      10: "2xl:w-[0.6390625vw] lg:w-2.5 md:w-2 w-1.5 2xl:h-[0.6390625vw] lg:h-2.5 md:h-2 h-1.5"
    },

    mainWrapper:{
      4:"4 w-full 2xl:max-w-[calc(100%/2-2.5vw)] xl:max-w-[calc(100%/2-28px)] lg:max-w-[calc(100%/2-20px)] md:max-w-[calc(100%/2-12px)] landscape:max-lg:max-w-[calc(100%/2-12px)] max-w-[calc(100%/2-4px)] flex flex-col ",
      5:"4 w-full 2xl:max-w-[calc(100%/5-0.7vw)] xl:max-w-[calc(100%/5-7px)] xs:max-w-[calc(100%/4-6px)]  landscape:max-lg:max-w-[calc(100%/3-4px)] landscape:max-md:max-w-[calc(100%/2-2px)] portrait:max-md:max-w-[calc(100%/2-2px)] flex flex-col",
      6: "6 w-full 2xl:max-w-[calc(100%/3-2.7vw)] xl:max-w-[calc(100%/3-32px)] lg:max-w-[calc(100%/3-11px)] md:max-w-[calc(100%/3-8px)] xs:max-w-[calc(100%/3-5px)] portrait:max-md:max-w-[calc(100%/2-5px)] flex flex-col",
      7: "7 w-full 2xl:max-w-[calc(100%/3-1.25vw)] xl:max-w-[calc(100%/3-8px)] lg:max-w-[calc(100%/3-12px)] md:max-w-[calc(100%/3-8px)] xs:max-w-[calc(100%/3-5px)] portrait:max-md:max-w-[calc(100%/2-5px)] flex flex-col",
      8: "8 w-full 2xl:max-w-[calc(100%/4-1.2vw)] xl:max-w-[calc(100%/4-18px)] lg:max-w-[calc(100%/4-12px)] md:max-w-[calc(100%/4-6px)] sm:max-w-[calc(100%/4-5px)] landscape:max-lg:max-w-[calc(100%/4-6px)] landscape:max-md:max-w-[calc(100%/3-3px)] max-w-[calc(100%/2-2px)] flex flex-col",
      9: "9 w-full 2xl:max-w-[calc(100%/5-1vw)] xl:max-w-[calc(100%/5-13px)] xs:max-w-[calc(100%/4-6px)]  landscape:max-lg:max-w-[calc(100%/3-4px)] landscape:max-md:max-w-[calc(100%/2-2px)] portrait:max-md:max-w-[calc(100%/2-2px)] flex flex-col",
      10: "10 w-full 2xl:max-w-[calc(100%/5-1.2vw)] xl:max-w-[calc(100%/5-20px)] lg:max-w-[calc(100%/5-13px)] xs:max-w-[calc(100%/5-7px)]  landscape:max-lg:max-w-[calc(100%/5-7px)] landscape:max-md:max-w-[calc(100%/2-2px)] portrait:max-md:max-w-[calc(100%/2-2px)] flex flex-col"},
    childeWrapper:{
      4:"4 px-0 2xl:py-[0.208vw] py-1 transition-all duration-300 flex flex-1  justify-between 2xl:items-center landscape:max-lg:py-1.5 h-full",
      5:"5 px-0 2xl:py-[0.208vw] py-1 transition-all duration-300 flex flex-1 justify-between 2xl:items-center landscape:max-lg:py-1.5 h-full",
      6: "6 px-0 2xl:py-[0.208vw] py-1 transition-all duration-300 flex flex-row flex-1 justify-between landscape:max-lg:py-1.5",
      7: "7 px-0 2xl:py-[0.208vw] py-1 transition-all duration-300 flex flex-row flex-1 justify-between landscape:max-lg:py-1.5",
      8: "8 px-0 2xl:py-[0.208vw] py-1 transition-all duration-300 flex flex-1 justify-between  landscape:max-lg:py-1.5 h-full",
      9: "9 px-0 2xl:py-[0.208vw] py-1 transition-all duration-300 flex flex-1 justify-between  landscape:max-lg:py-1.5 h-full",
      10: "10 px-0 2xl:py-[0.208vw] py-1 transition-all duration-300 flex flex-1 justify-between  landscape:max-lg:py-1.5 h-full"
    },
    categoryWrapper:{
      4:"flex-none items-center 2xl:mb-0 xl:mb-0 lg:mb-0 md:mb-0 mb-0 landscape:max-lg:mb-0",
      5:"flex-none 2xl:mb-0 xl:mb-0 lg:mb-0 md:mb-0 mb-0 landscape:max-lg:mb-0",
      6: "flex-none items-center 2xl:mb-0 xl:mb-0 lg:mb-0 md:mb-0 mb-0 landscape:max-lg:mb-0",
      7: "flex-none 2xl:mb-0 xl:mb-0 lg:mb-0 md:mb-0 mb-0 landscape:max-lg:mb-0",
      8: "flex-none 2xl:mb-0 xl:mb-0 lg:mb-0 md:mb-0 mb-0 landscape:max-lg:mb-0",
      9: "flex-none 2xl:mb-0 xl:mb-0 lg:mb-0 md:mb-0 mb-0 landscape:max-lg:mb-0",
      10:"flex-none 2xl:mb-0 xl:mb-0 lg:mb-0 md:mb-0 mb-0 landscape:max-lg:mb-0"
    },
    categoryImage:{
      4:"2xl:h-[10vw] xl:h-[9rem] lg:h-[7rem] md:h-[5rem] sm:h-[80px] xs:h-25 landscape:max-lg:h-29 h-22 landscape:max-md:h-18 2xl:max-w-full bg-transparent mx-auto object-contain",
      5:"w-full 2xl:h-[8.5vw] xl:h-[7rem] lg:h-[7rem] md:h-[5rem] sm:h-[80px] xs:h-25 landscape:max-lg:h-19.5 h-16 landscape:max-md:h-18 2xl:max-w-full bg-transparent mx-auto object-contain",
      6: "2xl:h-[10.5vw] xl:h-[8rem] lg:h-[7rem] md:h-[5rem] sm:h-[80px] xs:h-25 landscape:max-lg:h-29 h-20 landscape:max-md:h-18 bg-transparent landscape:max-lg:h-[7rem] object-contain",
      7: "w-full 2xl:h-[8.5vw] xl:h-[6rem] lg:h-[5rem] md:h-[6rem] sm:h-[60px] h-12 2xl:max-w-[8.33vw] xl:max-w-[160px] mx-auto bg-transparent landscape:max-lg:max-w-[57px] landscape:max-lg:h-[72px] portrait:max-sm:h-[62px] object-contain",
      8: "2xl:h-[10.5vw] xl:h-[8rem] lg:h-[7rem] md:h-[5rem] sm:h-[80px] xs:h-25 landscape:max-lg:h-29 h-20 landscape:max-md:h-18 landscape:max-lg:h-[6rem] 2xl:max-w-full bg-transparent mx-auto object-contain",
      9: "2xl:h-[10.5vw] xl:h-[8rem] lg:h-[7rem] md:h-[5rem] sm:h-[80px] xs:h-25 landscape:max-lg:h-29 h-20 landscape:max-md:h-18 landscape:max-lg:h-[6rem] 2xl:max-w-full bg-transparent mx-auto object-contain",
      10:"2xl:h-[10.5vw] xl:h-[8rem] lg:h-[7rem] md:h-[5rem] sm:h-[80px] xs:h-25 landscape:max-lg:h-29 h-20 landscape:max-md:h-18 landscape:max-lg:h-[4.7rem] 2xl:max-w-full bg-transparent mx-auto object-contain"
    },
    levelWrapper:{
      4: "flex flex-col 2xl:gap-[0.208vw] gap-1 2xl:w-full flex-1 justify-between",
      5: "flex flex-col 2xl:gap-[0.208vw] gap-1 justify-between 2xl:w-full flex-1",
      6: "flex flex-col 2xl:gap-[0.208vw] gap-1 flex-1 justify-between ",
      7: "flex flex-col 2xl:gap-[0.208vw] gap-1 flex-1 justify-center ",
      8: "flex flex-col 2xl:gap-[0.208vw] gap-1 flex-1",
      9: "flex flex-col 2xl:gap-[0.208vw] gap-1 flex-1",
      10: "flex flex-col 2xl:gap-[0.208vw] gap-1 flex-1  items-center justify-center"
    },
    level:{
      4:"2xl:py-[0.6vw] 2xl:px-[0.2vw] lg:px-1 px-0.5 lg:p-1 md:p-2 portrait:max-lg:p-1 p-1 landscape:max-lg:py-1 flex flex-1 items-center justify-center font-semibold 2xl:text-[0.625vw] md:text-xs/tight text-[10px]/tight cursor-pointer",
      5:"2xl:py-[0.6vw] 2xl:px-[0.2vw] lg:px-1 px-0.5 lg:p-1 md:p-2 portrait:max-lg:p-1 p-1 landscape:max-lg:py-1 flex flex-1 items-center justify-center font-semibold 2xl:text-[0.625vw] md:text-xs/tight text-[10px]/tight cursor-pointer",
      6: "2xl:py-[0.4vw] 2xl:px-[0.2vw] lg:px-1 px-0.5 lg:py-0.75 md:p-1.5 p-1 landscape:max-lg:py-1 flex flex-1 items-center justify-center font-semibold cursor-pointer 2xl:text-[0.625vw] md:text-xs/tight text-[10px]/tight",
      7: "2xl:py-[0.6vw] 2xl:px-[0.2vw] lg:px-1 px-0.5 lg:py-0.75 md:p-1.5 p-1 landscape:max-lg:py-1 flex items-center justify-center font-semibold cursor-pointer",
      8: "2xl:py-[0.6vw] 2xl:px-[0.2vw] lg:px-1 px-0.5 lg:py-1 md:p-2 portrait:max-lg:p-0.5 p-1 landscape:max-lg:py-1 flex items-center justify-center font-semibold 2xl:text-[0.625vw] md:text-xs/tight text-[10px]/tight cursor-pointer flex-1",
      9: "2xl:py-[0.6vw] 2xl:px-[0.2vw] lg:px-1 px-0.5 lg:py-1 md:p-2 portrait:max-lg:p-0.5 p-1 landscape:max-lg:py-1 flex items-center justify-center font-semibold 2xl:text-[0.625vw] md:text-xs/tight text-[10px]/tight cursor-pointer flex-1",
      10:"2xl:py-[0.25vw] 2xl:px-[0.2vw] lg:px-0 px-0.5 lg:py-0 lg:p-0 md:p-2 p-1 portrait:max-lg:p-0.5 landscape:max-lg:py-1 flex items-center justify-center font-semibold cursor-pointer w-full flex-1"
    },
    points:{
      4:"font-semibold 2xl:text-[2vw]/none xl:text-[1.8vw]/none lg:text-[1.5vw]/none sm:text-[16px]/none text-[16px]/none  landscape:max-md:text-[14px]/none",
      5:"font-semibold 2xl:text-[0.9375vw]/none xl:text-lg/tight lg:text-sm/none sm:text-[10px]/none text-[8px]/none landscape:max-lg:text-[10px]/none",
      6: "font-semibold 2xl:text-[2vw]/none xl:text-[1.5vw]/none lg:text-[1.5vw]/none sm:text-[16px]/none text-[16px]/none landscape:max-md:text-[14px]/none",
      7: "font-semibold 2xl:text-[0.833vw]/none xl:text-base/tight lg:text-sm/none sm:text-[10px]/none text-[8px]/none landscape:max-lg:text-[10px]/none",
      8: "font-semibold 2xl:text-[1.7vw]/none xl:text-[1.5vw]/none lg:text-[1.5vw]/none sm:text-[16px]/none text-[16px]/none landscape:max-md:text-[14px]/none landscape:max-md:text-xs/none",
      9: "font-semibold 2xl:text-[1.7vw]/none xl:text-[1.5vw]/none lg:text-[1.5vw]/none sm:text-[16px]/none text-[16px]/none landscape:max-md:text-[14px]/none landscape:max-md:text-xs/none",
      10:"font-semibold 2xl:text-[1.7vw]/none xl:text-[1.5vw]/none lg:text-[1.5vw]/none md:text-[16px]/none text-xs/none landscape:max-lg:text-xs/none landscape:max-md:text-xs/none"
    }
  };

  return (
    <>
      <div className={`w-full  ${categories?.length >= 6 ?  "2xl:max-w-[95vw] md:max-w-[95vw]" :"2xl:max-w-[72vw] lg:max-w-[72vw]"} mx-auto 2xl:px-[0.833vw] xl:px-6 px-2 relative z-20 h-full overflow-hidden ${categories?.length == 4 && "w-full md:max-w-[72vw]"}`}>
        {/* 29.5px  */}
        <div className={`sliderParentClass h-full justify-start flex flex-col ${classNamesCategoryGrid.mainWrapperSpacing[categories?.length]} `}>
          
          <div className="w-full h-full overflow-auto overflow-x-hidden justify-center flex flex-col items-center flex-1">
           {/* <h1 className="2xl:text-[3vw]/[3vw] xl:text-3xl/7 md:text-xl/5 text-lg/5 landscape:max-lg:text-base/4 font-garamond font-bold text-center text-primary-violet 2xl:mb-[0.5vw] mb-2 landscape:max-lg:mb-1 capitalize">
               {t("boardSlider.turn", { teamName: turnTeamName || "" })}
          </h1> */}
            <div
              className={`w-full flex 2xl:gap-[1.2vw] xl:gap-4 lg:gap-2 md:gap-1 gap-0.75 flex-wrap landscape:items-center ${categories?.length == 4 && "2xl:gap-x-[5vw] xl:gap-x-14 lg:gap-x-10 md:gap-x-6 gap-x-2"} ${categories?.length == 6 && "2xl:gap-x-[4vw] xl:gap-x-12 lg:gap-x-4 md:gap-x-2 gap-x-0.75"}
                ${categories?.length == 8 && "2xl:gap-x-[1.5vw] xl:gap-x-6 lg:gap-x-4 md:gap-x-2 gap-x-0.75"} ${categories?.length == 10 && "2xl:gap-x-[1.5vw] xl:gap-x-6 lg:gap-x-4 md:gap-x-2 gap-x-0.75"} `}
            >
              {categories?.map((category, index) => (
                //mainwraper
                <div key={index} className={`${classNamesCategoryGrid.mainWrapper[categories?.length]}`} >
                  <div className="w-full">
                    <p className="2xl:rounded-[0.417vw] rounded-lg bg-brown-primary-light text-center font-semibold 2xl:text-[1.563vw]/tight xl:text-xl/tight lg:text-xl/tight md:text-lg/tight landscape:max-lg:text-base/tight landscape:max-md:text-xs/tight text-base/tight max-[375px]:text-sm/tight 2xl:px-[0.83vw] lg:px-3 md:px-2.5 sm:px-2 px-1.5 2xl:py-[0.5vw] py-1 landscape:max-md:py-0.5 ">
                    {category?.title}
                    </p>
                    </div>
                  {/* childwrapper  */}
                  <div
                    className={`${classNamesCategoryGrid.childeWrapper[categories?.length]}`}
                  >
                    {/* levelWrapper */}
                    <div className={`${classNamesCategoryGrid.levelWrapper[categories?.length]}`} >
                      {category.levels.map((level, levelIdx) => {


                        const question = level.questions[0];

                        const handleLevelClick = () => {
                          if (question?.answered_by === null && question?.is_timeout !== true) {
                            // Navigate to the answer page with the game ID, category ID, and question ID
                            navigate(`/game/${gameId}/answer/${category.id}/${question._id}`);
                          } else {
                            return
                            // All questions in this level are answered or timed out
                            // useToast(t("boardSlider.thisLevelIsCompleted"), "info");
                          }
                        };
                        return (
                          // level
                          <div
                            key={levelIdx}
                            onClick={handleLevelClick}
                            className={`${classNamesCategoryGrid.level[categories?.length]}
                            ${question.answered_by !== null || question.is_timeout === true ? "opacity-40" : ""} 
                            text-black-300 bg-brown-primary-light  ltr:rounded-l-full rtl:rounded-r-full
                            `}
                          >
                            {/* points */}
                            <span
                             className={`${classNamesCategoryGrid.points[categories?.length]} 
                           ${levelIdx === 0 ? "text-black-300" : levelIdx === 1 ? "text-black-300" : "text-black-300"
                                }`}
                             
                            >
                              {level.points}
                            </span>
                            {/* <LevelDots questions={level.questions} /> */}
                          </div>
                        );
                      })}
                    </div>
                  {/* categorywrapper  */}
                    <div  className={`flex flex-1 ${classNamesCategoryGrid.categoryWrapper[categories?.length]}`} >
                      {/* Image Section */}
                      {/* <CategoryCardImage
                        src={category?.img}
                        alt={category?.title || "category"}
                        className={classNamesCategoryGrid.categoryImage[categories?.length]}
                        priority={index < 3}
                      /> */}
                       <img
       src={category?.img}
                        alt={category?.title || "category"}
    
                              className={`flex flex-1 ${classNamesCategoryGrid.categoryImage[categories?.length]}`}

        // ${isLoaded ? "opacity-100" : "opacity-0"}
      />
                      {/*<div
                        className={`2xl:pb-[0.417vw] pb-2 2xl:pt-[4.3vw] lg:pt-[85px] pt-18 h-full flex flex-col justify-center board-inner-shape ${category.gredientBg}`}
                      >
                        <h3 className="font-semibold 2xl:text-[1.667vw]/[1.7vw] lg:text-3xl/tight text-2xl/tight text-white font-garamond text-center 2xl:px-[0.833vw] px-4 2xl:min-h-[4vw] lg:min-h-[72px] min-h-[56px] flex items-center justify-center">
                          {category.title}
                        </h3> 
                      </div>*/}
                    </div>

                    {/* Levels */}
                    {/* levelWrapper */}
                    <div className={`${classNamesCategoryGrid.levelWrapper[categories?.length]}`} >
                      {category.levels.map((level, levelIdx) => {
                        const question = level.questions[1];

                        const handleLevelClick = () => {
                          if (question?.answered_by === null && question?.is_timeout !== true) {
                            // Navigate to the answer page with the game ID, category ID, and question ID
                            navigate(`/game/${gameId}/answer/${category.id}/${question._id}`);
                          } else {
                            return
                            // All questions in this level are answered or timed out
                            // useToast(t("boardSlider.thisLevelIsCompleted"), "info");
                          }
                        };
                                              
                        return (
                          // level
                          <div
                            key={levelIdx}
                            onClick={handleLevelClick}
                            className={`${classNamesCategoryGrid.level[categories?.length]} 
                            ${question.answered_by !== null || question.is_timeout === true ? "opacity-40" : ""}
                              text-black-300 bg-brown-primary-light ltr:rounded-r-full
                            rtl:rounded-l-full `}
                          >
                            {/* points */}
                            <span
                             className={`${classNamesCategoryGrid.points[categories?.length]} 
                           ${levelIdx === 0 ? "text-black-300" : levelIdx === 1 ? "text-black-300" : "text-black-300"
                                }`}
                             
                            >
                              {level.points}
                            </span>
                            {/* <LevelDots questions={level.questions} /> */}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              ))}
              
            </div>
          </div>
          {/* <div className="w-full">
            <div className="flex lg:gap-[0.7vw] gap-2 justify-between 2xl:my-[0.833vw] md:my-10 mt-4 mb-5"> */}
          {/* change md:my to 4 on add logoipsum */}
          {/* <a href="#" className="2xl:p-[0.833vw] lg:p-4 p-3 bg-white 2xl:rounded-[0.781vw] rounded-[15px]">
                <img
                  src={FooterBlueLogo}
                  alt=""
                  className="2xl:max-w-[6.25vw] max-w-[120px] 2xl:h-[1.563vw] h-[30px] w-full block"
                />
              </a>
              <a href="#" className="2xl:p-[0.833vw] lg:p-4 p-3 bg-white 2xl:rounded-[0.781vw] rounded-[15px]">
                <img
                  src={FooterLogoipsumLogo}
                  alt=""
                  className="2xl:max-w-[6.25vw] max-w-[120px] 2xl:h-[1.563vw] h-[30px] w-full block"
                />
              </a> */}
          {/* </div>
          </div> */}
        </div>
      </div >
      {/* {(isLessThanXl || (!isLessThanXl && categories.length > 4)) && (
        <div className="absolute z-20 start-1/2 ltr:-translate-x-1/2 rtl:translate-x-1/2 2xl:bottom-[1vw] md:bottom-3 sm:bottom-5 bottom-3 w-fit mx-auto flex items-center justify-center 2xl:rounded-[1.458vw] rounded-[28px] 2xl:px-[0.833vw] px-4 2xl:py-[0.625vw] py-4 2xl:border-[0.26vw] border-5 bg-purple-fill border-transparent [background:padding-box_linear-gradient(#453C99,#7364FF),_border-box_linear-gradient(#7364FF,#453C99)]">
          <div className="flex 2xl:gap-[1.458vw] xl:gap-7 gap-4">
            <button className="group arrow-left arrow cursor-pointer 2xl:w-[3.646vw] lg:w-[70px] md:w-14 w-10 rtl:-scale-x-100 lg:px-[0.208vw] px-1 focus:outline-none">
              <svg width="100%" height="auto" viewBox="0 0 67 47" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M60.2094 9.66544H36.6127C36.1794 9.66352 35.7646 9.48962 35.4595 9.18196C35.1544 8.87431 34.984 8.45809 34.9857 8.02482V6.16216C34.9857 1.32464 29.703 -1.62056 25.6388 0.951397L4.86891 14.0949C-1.60541 18.1918 -1.62618 27.6956 4.83008 31.8213L26.2402 45.503C30.0324 47.9263 34.9852 45.1795 34.9852 40.653V37.0179H60.2094C61.9428 37.0109 63.6025 36.3155 64.8232 35.0848C66.044 33.8541 66.7258 32.1889 66.7188 30.4554V16.2279C66.7258 14.4945 66.044 12.8293 64.8232 11.5986C63.6025 10.3679 61.9428 9.6725 60.2094 9.66544Z"
                  fill="#C3DC78"
                  className="transition-all duration-300"
                />
                <path
                  d="M4.86851 14.0948C2.5659 15.5515 1.72398 18.0954 1.69239 20.5616C1.65493 23.5234 2.96278 25.9087 5.32146 27.5116C10.4521 30.9979 26.2404 40.7186 26.2404 40.7186C30.0325 43.142 34.9853 40.3952 34.9853 35.8687V34.4115C34.9836 33.9782 35.154 33.562 35.4591 33.2543C35.7642 32.9467 36.179 32.7728 36.6123 32.7709H60.2094C61.9428 32.7638 63.6024 32.0684 64.8232 30.8377C66.0439 29.607 66.7258 27.9418 66.7188 26.2084V30.4554C66.7258 32.1889 66.044 33.8541 64.8232 35.0848C63.6025 36.3155 61.9428 37.0109 60.2094 37.0179H34.9848V40.653C34.9848 45.1795 30.032 47.9265 26.2398 45.503L4.82968 31.8213C-1.62686 27.6956 -1.6058 18.1918 4.86851 14.0948Z"
                  fill="#C3DC78"
                  className="transition-all duration-300"
                />
                <path
                  d="M4.86851 14.0948C2.5659 15.5515 1.72398 18.0954 1.69239 20.5616C1.65493 23.5234 2.96278 25.9087 5.32146 27.5116C10.4521 30.9979 26.2404 40.7186 26.2404 40.7186C30.0325 43.142 34.9853 40.3952 34.9853 35.8687V34.4115C34.9836 33.9782 35.154 33.562 35.4591 33.2543C35.7642 32.9467 36.179 32.7728 36.6123 32.7709H60.2094C61.9428 32.7638 63.6024 32.0684 64.8232 30.8377C66.0439 29.607 66.7258 27.9418 66.7188 26.2084V30.4554C66.7258 32.1889 66.044 33.8541 64.8232 35.0848C63.6025 36.3155 61.9428 37.0109 60.2094 37.0179H34.9848V40.653C34.9848 45.1795 30.032 47.9265 26.2398 45.503L4.82968 31.8213C-1.62686 27.6956 -1.6058 18.1918 4.86851 14.0948Z"
                  fill="black"
                  fill-opacity="0.2"
                />
              </svg>
            </button>
            <button className="group arrow-right arrow cursor-pointer 2xl:w-[3.646vw] lg:w-[70px] md:w-14 w-10 rtl:-scale-x-100 lg:px-[0.208vw] px-1 focus:outline-none">
              <svg width="100%" height="auto" viewBox="0 0 67 47" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M6.50951 9.66544H30.1062C30.5395 9.66352 30.9543 9.48962 31.2594 9.18196C31.5644 8.87431 31.7349 8.45809 31.7332 8.02482V6.16216C31.7332 1.32464 37.0158 -1.62056 41.0801 0.951397L61.85 14.0949C68.3243 18.1918 68.3451 27.6956 61.8888 31.8213L40.4786 45.503C36.6865 47.9263 31.7337 45.1795 31.7337 40.653V37.0179H6.50951C4.77606 37.0109 3.11642 36.3155 1.89567 35.0848C0.674912 33.8541 -0.00695888 32.1889 5.35568e-05 30.4554V16.2279C-0.00695888 14.4945 0.674912 12.8293 1.89567 11.5986C3.11642 10.3679 4.77606 9.6725 6.50951 9.66544Z"
                  fill="#C3DC78"
                  className="transition-all duration-300"
                />
                <path
                  d="M61.8504 14.0948C64.153 15.5515 64.9949 18.0954 65.0265 20.5616C65.064 23.5234 63.7561 25.9087 61.3974 27.5116C56.2668 30.9979 40.4785 40.7186 40.4785 40.7186C36.6863 43.142 31.7336 40.3952 31.7336 35.8687V34.4115C31.7353 33.9782 31.5649 33.562 31.2598 33.2543C30.9547 32.9467 30.5399 32.7728 30.1066 32.7709H6.50951C4.77608 32.7638 3.11645 32.0684 1.89571 30.8377C0.67496 29.607 -0.00692258 27.9418 5.35568e-05 26.2084V30.4554C-0.00695888 32.1889 0.674912 33.8541 1.89567 35.0848C3.11642 36.3155 4.77606 37.0109 6.50951 37.0179H31.7341V40.653C31.7341 45.1795 36.6869 47.9265 40.4791 45.503L61.8892 31.8213C68.3457 27.6956 68.3247 18.1918 61.8504 14.0948Z"
                  fill="#C3DC78"
                  className="transition-all duration-300"
                />
                <path
                  d="M61.8504 14.0948C64.153 15.5515 64.9949 18.0954 65.0265 20.5616C65.064 23.5234 63.7561 25.9087 61.3974 27.5116C56.2668 30.9979 40.4785 40.7186 40.4785 40.7186C36.6863 43.142 31.7336 40.3952 31.7336 35.8687V34.4115C31.7353 33.9782 31.5649 33.562 31.2598 33.2543C30.9547 32.9467 30.5399 32.7728 30.1066 32.7709H6.50951C4.77608 32.7638 3.11645 32.0684 1.89571 30.8377C0.67496 29.607 -0.00692258 27.9418 5.35568e-05 26.2084V30.4554C-0.00695888 32.1889 0.674912 33.8541 1.89567 35.0848C3.11642 36.3155 4.77606 37.0109 6.50951 37.0179H31.7341V40.653C31.7341 45.1795 36.6869 47.9265 40.4791 45.503L61.8892 31.8213C68.3457 27.6956 68.3247 18.1918 61.8504 14.0948Z"
                  fill="black"
                  fill-opacity="0.2"
                />
              </svg>
            </button>
          </div>
        </div>
      )} */}
    </>
  );
}


  //  {categories.map((category, index) => {
  //               if (index > 2) return null;
  //               return (
  //                 <div key={index} className={`${classNamesCategoryGrid.mainwraper[categories?.length]}` }>
  //                   <div
  //                     className="2xl:p-[0.625vw] lg:p-3 md:p-2.5 sm:p-2 p-1.5 2xl:rounded-[0.6390625vw] rounded-xl landscape:max-lg:rounded-lg 2xl:border-[0.1041vw] border-[1.8px] border-primary bg-white transition-all duration-300 flex flex-col flex-1 justify-between landscape:max-lg:flex-row landscape:max-lg:gap-1 landscape:max-lg:p-1.5"
  //                   >
  //                     <div className="2xl:mb-[0.625vw] xl:mb-2.5 lg:mb-2 md:mb-1.5 mb-1 landscape:max-lg:mb-0 landscape:max-lg:w-max">
  //                       {/* Image Section */}
  //                       <img
  //                         src={category.img}
  //                         alt=""
  //                         className="w-full 2xl:h-[5.313vw] xl:h-[102px] lg:h-20 md:h-[72px] sm:h-[60px] h-10 max-w-max mx-auto bg-transparent landscape:max-lg:max-w-[57px] landscape:max-lg:max-h-[72px]"
  //                       />
  //                       {/*<div
  //                         className={`2xl:pb-[0.417vw] pb-2 2xl:pt-[4.3vw] lg:pt-[85px] pt-18 h-full flex flex-col justify-center board-inner-shape ${category.gredientBg}`}
  //                       >
  //                         <h3 className="font-semibold 2xl:text-[1.667vw]/[1.7vw] lg:text-3xl/tight text-2xl/tight text-white font-garamond text-center 2xl:px-[0.833vw] px-4 2xl:min-h-[4vw] lg:min-h-[72px] min-h-[56px] flex items-center justify-center">
  //                           {category.title}
  //                         </h3> 
  //                       </div>*/}
  //                     </div>

  //                     {/* Levels */}
  //                     <div className="flex flex-col 2xl:gap-[0.3125vw] lg:gap-1.5 md:gap-1 gap-1 landscape:max-lg:w-[calc(100%-57px)]">
  //                       {category.levels.map((level, levelIdx) => {
  //                         const handleLevelClick = () => {
  //                           // Find the first unanswered question (not answered AND not timed out)
  //                           const unansweredQuestion = level.questions?.find(
  //                             (q: any) => q.answered_by === null && q.is_timeout !== true
  //                           );

  //                           if (unansweredQuestion) {
  //                             // Navigate to the answer page with the game ID, category ID, and question ID
  //                             navigate(`/game/${gameId}/answer/${category.id}/${unansweredQuestion._id}`);
  //                           } else {
  //                             // All questions in this level are answered or timed out
  //                             useToast(t("boardSlider.thisLevelIsCompleted"), "info");
  //                           }
  //                         };
  //                         return (
  //                           <div
  //                             key={levelIdx}
  //                             onClick={handleLevelClick}
  //                             className={`xl:rounded-[0.340vw] rounded-[4.6px] 2xl:py-[0.25vw] 2xl:px-[0.47vw] lg:p-2 md:p-1.5 p-1 landscape:max-lg:p-1 flex items-center justify-between font-semibold 2xl:text-[0.625vw] md:text-xs/tight text-[10px]/tight cursor-pointer 2xl:shadow-[0px_0.068vw_0px_0px_#110706] shadow-[0px_0.98px_0px_0px_#110706] ${levelIdx === 0
  //                               ? "text-black-300 bg-purple-fill lg:border-[0.0401vw] border-[0.77px] border-black-300  bg-primary-yellow"
  //                               : levelIdx === 1
  //                                 ? "text-black-300 bg-purple-fill lg:border-[0.0401vw] border-[0.77px] border-black-300 bg-sky-blue"
  //                                 : "text-black-300 bg-purple-fill lg:border-[0.0401vw] border-[0.77px] border-black-300 bg-primary-ivory"
  //                               }`}
  //                           >
  //                             <span
  //                               className={`font-semibold 2xl:text-[0.625vw]/none md:text-xs/none sm:text-[10px]/none text-[8px]/none landscape:max-lg:text-[10px]/none ${levelIdx === 0 ? "text-black-300" : levelIdx === 1 ? "text-black-300" : "text-black-300"
  //                                 }`}
  //                             >
  //                               {level.points}
  //                             </span>
  //                             <LevelDots questions={level.questions} />
  //                           </div>
  //                         );
  //                       })}
  //                     </div>
  //                   </div>
  //                 </div>
  //               )
  //             })}





              //  {categories.map((category, index) =>{
              //     if (index > 1) return null;
              //       return  (
              //                 //mainwraper
              //                 <div key={index} className={`${classNamesCategoryGrid.mainWrapper[categories?.length]}`} >
              //                   {/* childwrapper  */}
              //                   <div
              //                     className={`${classNamesCategoryGrid.childeWrapper[categories?.length]}`}
              //                   >
              //                   {/* categorywrapper  */}
              //                     <div  className={`${classNamesCategoryGrid.categoryWrapper[categories?.length]}`} >
              //                       {/* Image Section */}
              //                       <img
              //                         src={category.img}
              //                         alt=""
              //                       className={`${classNamesCategoryGrid.categoryImage[categories?.length]}`}
              //                       />
              //                       {/*<div
              //                         className={`2xl:pb-[0.417vw] pb-2 2xl:pt-[4.3vw] lg:pt-[85px] pt-18 h-full flex flex-col justify-center board-inner-shape ${category.gredientBg}`}
              //                       >
              //                         <h3 className="font-semibold 2xl:text-[1.667vw]/[1.7vw] lg:text-3xl/tight text-2xl/tight text-white font-garamond text-center 2xl:px-[0.833vw] px-4 2xl:min-h-[4vw] lg:min-h-[72px] min-h-[56px] flex items-center justify-center">
              //                           {category.title}
              //                         </h3> 
              //                       </div>*/}
              //                     </div>

              //                     {/* Levels */}
              //                     {/* levelWrapper */}
              //                     <div className={`${classNamesCategoryGrid.levelWrapper[categories?.length]}`} >
              //                       {category.levels.map((level, levelIdx) => {
              //                         const handleLevelClick = () => {
              //                           // Find the first unanswered question (not answered AND not timed out)
              //                           const unansweredQuestion = level.questions?.find(
              //                             (q: any) => q.answered_by === null && q.is_timeout !== true
              //                           );

              //                           if (unansweredQuestion) {
              //                             // Navigate to the answer page with the game ID, category ID, and question ID
              //                             navigate(`/game/${gameId}/answer/${category.id}/${unansweredQuestion._id}`);
              //                           } else {
              //                             // All questions in this level are answered or timed out
              //                             useToast(t("boardSlider.thisLevelIsCompleted"), "info");
              //                           }
              //                         };
              //                         return (
              //                           // level
              //                           <div
              //                             key={levelIdx}
              //                             onClick={handleLevelClick}
              //                             className={`${classNamesCategoryGrid.level[categories?.length]} 
              //                             ${levelIdx === 0
              //                               ? "text-black-300 bg-purple-fill lg:border-[0.0401vw] border-[0.77px] border-black-300  bg-primary-yellow"
              //                               : levelIdx === 1
              //                                 ? "text-black-300 bg-purple-fill lg:border-[0.0401vw] border-[0.77px] border-black-300 bg-sky-blue"
              //                                 : "text-black-300 bg-purple-fill lg:border-[0.0401vw] border-[0.77px] border-black-300 bg-primary-ivory"
              //                             }`}
              //                           >
              //                             {/* points */}
              //                             <span
              //                             className={`${classNamesCategoryGrid.points[categories?.length]} 
              //                           ${levelIdx === 0 ? "text-black-300" : levelIdx === 1 ? "text-black-300" : "text-black-300"
              //                                 }`}
                                          
              //                             >
              //                               {level.points}
              //                             </span>
              //                             <LevelDots questions={level.questions} />
              //                           </div>
              //                         );
              //                       })}
              //                     </div>
              //                   </div>
              //                 </div>
              //               )
              // })}